import gql from 'graphql-tag';

export const GET = gql`
  query getPost($input: GetPostInput!) {
    getPost(input: $input) {
      id
      title
      thumbnail
      isPublic
      seoName
      category
      description
      content
      createdTime
    }
  }
`;

export const LIST = gql`
  query listPosts($input: ListPostsInput!) {
    listPosts(input: $input) {
      id
      title
      thumbnail
      isPublic
      seoName
      category
      description
      createdTime
    }
  }
`;

export const LIST_PUBLIC = gql`
  query listPostsPublic($input: ListPostsPublicInput!) {
    listPostsPublic(input: $input) {
      totalPages
      page
      header {
        banner
        bannerBlur
        title
        description
      }
      featurePosts {
        id
        thumbnail
        title
        seoName
        description
        createdTime
      }
      results {
        id
        title
        thumbnail
        isPublic
        seoName
        category
        description
        createdTime
      }
      business {
        id
        title
        thumbnail
        isPublic
        seoName
        category
        description
        createdTime
      }
      exams {
        id
        title
        thumbnail
        isPublic
        seoName
        category
        description
        createdTime
      }
      blogs {
        id
        title
        thumbnail
        isPublic
        seoName
        category
        description
        createdTime
      }
    }
  }
`;

export const LIST_BLOG_PUBLIC = gql`
  query listBlogsPublic($input: ListBlogsPublicInput!) {
    listBlogsPublic(input: $input) {
      totalPages
      page
      results {
        id
        title
        thumbnail
        isPublic
        seoName
        category
        description
        createdTime
      }
    }
  }
`;

export const SEARCH = gql`
  query searchPosts($input: SearchPostsInput!) {
    searchPosts(input: $input) {
      totalPages
      totalResults
      page
      results {
        id
        title
        thumbnail
        isPublic
        seoName
        category
        description
        createdTime
        updatedTime
      }
    }
  }
`;

export const SEARCH_PUBLIC = gql`
  query searchPostsPublic($input: SearchPostsPublicInput!) {
    searchPostsPublic(input: $input) {
      totalPages
      totalResults
      page
      results {
        id
        title
        thumbnail
        isPublic
        seoName
        category
        description
        createdTime
        updatedTime
      }
    }
  }
`;
